export default __webpack_public_path__ + "static/media/recruit_table_icon_5.403349d5.svg";